import baseWs from './baseWs'
//import axios from 'axios';

export function loginCall (username, password) {
    return baseWs.post('/api/account/authenticate', { 
        usernameOrEmailAddress: username,
        password: password
     })
     .then(res => {
         return res;
     })
     .catch(err => {
         console.log('Error logging in: ' + err);
         throw err;
     })
}

export function getUserInfoCall () {
    return baseWs.post('/api/services/app/session/GetCurrentLoginInformations')
     .then(res => {
         return res;
     })
     .catch(err => {
         console.log('Error getting user info: ' + err);
         throw err;
     })
}

export function loadRolePermissionScripts () {

    return baseWs.get('/AbpScripts/GetScripts')
    .then(res => {
        return res;
    })
    .catch(err => {
        console.log('Error getting abp scripts: ' + err);
        throw err;
    })
}

// export function getRolePermissionScripts () {
//     return baseWs.get('/AbpScripts/GetScripts')
//     .then(res => {
//         var s = `var abp={timing: {unspecifiedClockProvider: {}}, clock: {}, security: {antiForgery: {}}, event:{trigger: function(){}}}; ${res.data}`;
//         console.log('in ws fetch:');
//         //console.log(res);
//         console.log(s.abp.localization.languages);
//         return res;
//     })
//     .catch(err => {
//         console.log('Error getting abp scripts: ' + err);
//         throw err;
//     })
// }

// export function helloWorldCall () {

//     return baseWs.post('/services/app/helloWorld/showSimpleHelloWorld')
//      .then(res => {
//          console.log(res);
//      })
//      .catch(err => {
//          console.log(err);
//      })
// }

// export function testPublicApi (){
//     const options = {
//         method: 'GET',
//         url: 'https://apidojo-yahoo-finance-v1.p.rapidapi.com/auto-complete',
//         params: {q: 'tesla', region: 'US'},
//         headers: {
//           'x-rapidapi-key': 'SIGN-UP-FOR-KEY',
//           'x-rapidapi-host': 'apidojo-yahoo-finance-v1.p.rapidapi.com'
//         }
//       };
      
//       axios.request(options).then(function (response) {
//           console.log(response.data);
//       }).catch(function (error) {
//           console.error(error);
//       });
// }